module.exports = __webpack_public_path__ + "img/podium_bg.e008a062.png";